"use strict";

var __importDefault = undefined && undefined.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("bootstrap-3-typeahead/bootstrap3-typeahead.js");
var iv_viewer_1 = __importDefault(require("iv-viewer"));
$.fn.callBackDocSearch = function () {
    var $container = $(this);
    var $tds = $container.find("table:first").find("td");
    if ($tds.length > 0 && $tds.filter(function (i, td) {
        return typeof $(td).attr("colspan") !== "undefined";
    }).length === 0) {
        $container.setDatatableAdmin({ order: [] });
    }
    return $container;
};
var dateFormat = function dateFormat($dateTimePicker) {
    return $dateTimePicker.viewDate().set("hour", 0).set("minute", 0).set("second", 0).set("millisecond", 0).toISOString();
};
$.fn.getNbreFilesToDelete = function ($button) {
    var $body = $(this),
        dateref = dateFormat($("input#dateRef").data('DateTimePicker'));
    $body.load($button.data("url") + "?dateRef=" + dateref, function (data) {
        data = JSON.parse(data);
        if (data.nbre <= 0) {
            $body.next().find(".btn-success").hide();
        }
        $body.html(data.message);
    });
};
$(function () {
    $("input#dateRef").initDateTimePicker().on("dp.change", function () {
        if ($(this).val()) {
            $(".action-supp .btn").removeAttr("disabled");
        } else {
            $(".action-supp .btn").attr("disabled", "disabled");
        }
    });
    $("div.action-supp .btn-nb-file").on("click", function () {
        var $this = $(this),
            $divInfo = $this.parents("form").find("div.alert-info"),
            dateref = dateFormat($("input#dateRef").data('DateTimePicker'));
        $.get($this.data("url") + "?dateRef=" + dateref, function (data) {
            $divInfo.find(">span").html("Le nombre de fichier \xE0 supprimer pour cette date est : " + data.nbre);
            $divInfo.addClass("show");
        });
    });
    var $dtContainer = $(".result-doc-box");
    if ($dtContainer.length > 0) {
        var $btnSearch = $("button.btn-doc-search"),
            $input = $(".input-search-doc");
        var options = {
            source: function source(query, result) {
                $.ajax({
                    url: $input.data("url"),
                    data: 'term=' + $input.val(),
                    dataType: "json",
                    success: function success(data) {
                        result(data.results);
                    }
                });
            },
            updater: function updater(item) {
                var url = $input.data("search-url"),
                    term = item.text || $input.val(),
                    $process = $(".datatable-processing");
                $process.show();
                $dtContainer.load(url + "?term=" + escape(term), function () {
                    $dtContainer.callBackDocSearch();
                    $input.val(term);
                    $process.hide();
                });
            },
            fitToElement: true,
            skipShowHintOnFocus: false,
            showHintOnFocus: false,
            items: 10,
            minLength: 3,
            displayText: function displayText(item) {
                return item.text;
            }
        };
        //permet la recherche de document avec la touche entrée en cas d'autocomplete cachée
        $input.typeahead(options).on("keyup", function (e) {
            var tah = $input.data("typeahead");
            if (!tah.shown && e.keyCode === 13) {
                tah.select();
            }
        }).on("click", function (e) {
            var tah = $input.data('typeahead');
            if (tah.focused) {
                $.ajax({
                    url: $input.data("url"),
                    data: 'term=' + $input.val(),
                    dataType: "json",
                    success: function success(data) {
                        tah.query = $input.val() || "";
                        tah.process(data.results.filter(function (i) {
                            return i.text !== null;
                        }));
                    }
                });
            }
        });
    }
    // Aperçu des images
    var container = $('.image-preview-container');
    if (container.length) {
        new iv_viewer_1.default(container[0]);
    }
});


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Document/index.ts
// module id = 607
// module chunks = 0